import { Rutas } from '@/constants/rutas';
import CustomLink from '../shared/custom/custom-link';
import { LEAGUES } from '@/constants/leagues';
import { Box, Typography, useTheme } from '@mui/material';
import { getApiFootballTeamImageById, getTeamImageById } from '@/helpers/images-helper';
import CustomImageComponent from '../shared/custom/custom-image';

export const TeamStreak = ({ streak }) => {
    const theme = useTheme();
    const getStreak = () => {
        if (!streak) return [];
        return Array.from(streak);
    };

    const getGameStyles = (s) => {
        const commonStyles = {
            width: '16px',
            height: '16px',
            borderRadius: '2px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#fff',
            fontSize: '10px',
        };

        switch (s) {
            case 'W':
                return { backgroundColor: theme.resultadosBox.win, ...commonStyles };
            case 'L':
                return { backgroundColor: theme.resultadosBox.lose, ...commonStyles };
            case 'D':
                return { backgroundColor: theme.resultadosBox.draw, ...commonStyles };
            default:
                return { ...commonStyles };
        }
    };

    const translateToSpanish = (s) => {
        switch (s) {
            case 'W':
                return 'V';
            case 'L':
                return 'D';
            case 'D':
                return 'E';
            default:
                return '';
        }
    };
    return (
        <Box display="flex" gap={0.2}>
            {getStreak()?.map((s, i) => (
                <Box key={`${i}`} sx={getGameStyles(s)}>
                    <Typography variant="body2" color="#fff" fontSize={10}>
                        {translateToSpanish(s)}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};

const ClasificacionCompeticionesColumns = ({ leagueId, homeAway }) => {
    const getPoints = (standingTeam) => {
        if (!standingTeam) return 0;
        return standingTeam.win * 3 + standingTeam.draw;
    };

    const columns = [
        {
            id: 'position',
            name: '',
            center: true,
            width: '50px',
            cell: (row) => <Typography fontSize={14}>{row.rank}</Typography>,
        },
        {
            id: 'Equipo',
            fixed: true,
            name: 'Equipo',
            center: true,
            width: '50px',
            cell: (row) => (
                <CustomLink
                    href={`${Rutas.EQUIPO}/${row.team?.slug}`}
                    disableLink={leagueId === LEAGUES.LA_LIGA}
                >
                    <Box display="flex" alignItems="center">
                        <CustomImageComponent
                            src={
                                leagueId === LEAGUES.LA_LIGA
                                    ? getTeamImageById(row.team?.id, 45)
                                    : getApiFootballTeamImageById(row.team?.id)
                            }
                            alt={row.team?.name}
                            width={30}
                            height={30}
                        />
                        <Box ml={0.5} display="flex" flexDirection="column">
                            <Typography textAlign="left" fontSize={14}>
                                {row.team?.name}
                            </Typography>
                            <TeamStreak streak={row.form} />
                        </Box>
                    </Box>
                </CustomLink>
            ),
        },
        {
            id: 'puntos',
            name: 'Pts',
            center: true,
            width: '50px',
            cell: (row) => <Typography fontSize={14}>{getPoints(row[homeAway])}</Typography>,
        },
        {
            id: 'pj',
            name: 'PJ',
            center: true,
            width: '50px',
            cell: (row) => <Typography fontSize={14}>{row[homeAway].played}</Typography>,
        },
        {
            id: 'g',
            name: 'G',
            center: true,
            width: '50px',
            cell: (row) => <Typography fontSize={14}>{row[homeAway].win}</Typography>,
        },
        {
            id: 'e',
            name: 'E',
            center: true,
            width: '50px',
            cell: (row) => <Typography fontSize={14}>{row[homeAway].draw}</Typography>,
        },
        {
            id: 'p',
            name: 'P',
            center: true,
            width: '50px',
            cell: (row) => <Typography fontSize={14}>{row[homeAway].lose}</Typography>,
        },
        {
            id: 'dg',
            name: 'DG',
            center: true,
            width: '50px',
            cell: (row) => (
                <Typography fontSize={14}>{row[homeAway].goals.for - row[homeAway].goals.against}</Typography>
            ),
        },
        {
            id: 'gf',
            name: 'GF',
            center: true,
            width: '50px',
            cell: (row) => <Typography fontSize={14}>{row[homeAway].goals.for}</Typography>,
        },
        {
            id: 'gc',
            name: 'GC',
            center: true,
            width: '50px',
            cell: (row) => <Typography fontSize={14}>{row[homeAway].goals.against}</Typography>,
        },
    ];

    return columns;
};

export default ClasificacionCompeticionesColumns;

// export const TABLE_HEADER = [
//     {
//         label: '',
//         align: 'center',
//     },
//     {
//         label: 'Equipo',
//         align: 'left',
//     },
//     {
//         label: 'Pts',
//         align: 'center',
//         text: 'Puntos',
//     },
//     {
//         label: 'PJ',
//         align: 'center',
//         text: 'Partidos jugados',
//     },
//     {
//         label: 'G',
//         align: 'center',
//         text: 'Partidos Ganados',
//     },
//     {
//         label: 'E',
//         align: 'center',
//         text: 'Partidos Empatados',
//     },
//     {
//         label: 'P',
//         align: 'center',
//         text: 'Partidos Perdidos',
//     },
//     {
//         label: 'DG',
//         align: 'center',
//         text: 'Diferencia de goles',
//     },
//     {
//         label: 'GF',
//         align: 'center',
//         text: 'Goles a favor',
//     },
//     {
//         label: 'GC',
//         align: 'center',
//         text: 'Goles en contra',
//     },
// ];
